<div class="main-layout">
  <div class="main-header-container">
    <app-quotation-top-header></app-quotation-top-header>
    <app-quotation-header (collapsedState)="onHeaderCollapse($event)"></app-quotation-header>
  </div>

  <div class="order-number-container" [class.expanded]="!isHeaderCollapsed" [class.collapsed]="isHeaderCollapsed">

    <!-- ===== PAGE HEADER ===== -->
    <div class="header-section">
      <div class="header-left">
        <h1>
          <i class="pi pi-list"></i>
          Order Number Generator
        </h1>
        <p class="user-info">
          <i class="pi pi-user"></i>
          {{ userDetails?.name }} ({{ userInitials }})
        </p>
      </div>

      <div class="header-right">
        <button pButton type="button" label="New Number" icon="pi pi-plus" (click)="openCreateDialog()"
          class="p-button-primary header-btn">
        </button>

        <button pButton type="button" label="Export" icon="pi pi-download" (click)="exportToCSV()"
          class="p-button-secondary header-btn">
        </button>
      </div>
    </div>

    <!-- ===== STATS ===== -->
    <div class="stats-section">
      <div class="stat-card">
        <span class="stat-icon"><i class="pi pi-ticket"></i></span>
        <span class="stat-value">{{ records.length }}</span>
        <span class="stat-label">Total Numbers</span>
      </div>

      <div class="stat-card">
        <span class="stat-icon"><i class="pi pi-calendar"></i></span>
        <span class="stat-value">{{ currentYear }}</span>
        <span class="stat-label">Current Year</span>
      </div>

      <div class="stat-card">
        <span class="stat-icon"><i class="pi pi-id-card"></i></span>
        <span class="stat-value">{{ userInitials }}</span>
        <span class="stat-label">Your Initials</span>
      </div>

      <div class="stat-card">
        <span class="stat-icon"><i class="pi pi-refresh"></i></span>
        <span class="stat-value">{{ replacementCount }}</span>
        <span class="stat-label">Replacements</span>
      </div>
    </div>

    <!-- ===== TABLE SECTION ===== -->
    <div class="table-section">

      <!-- Tabs + Search -->
      <div class="table-header-row">
        <div class="tabs-section">

          <!-- Encloser -->
          <button pButton type="button" [label]="'Encloser (' + encloserCount + ')'"
            [class]="{'p-button-primary': activeTab === 'E', 'p-button-secondary': activeTab !== 'E'}"
            (click)="activeTab = 'E'">
          </button>

          <!-- Sample -->
          <button pButton type="button" [label]="'Sample (' + sampleCount + ')'"
            [class]="{'p-button-primary': activeTab === 'ES', 'p-button-secondary': activeTab !== 'ES'}"
            (click)="activeTab = 'ES'">
          </button>

          <!-- Drawing -->
          <button pButton type="button" [label]="'Drawings (' + drawingCount + ')'"
            [class]="{'p-button-primary': activeTab === 'D', 'p-button-secondary': activeTab !== 'D'}"
            (click)="activeTab = 'D'">
          </button>

          <!-- Replacement TAB -->
          <button pButton type="button" [label]="'Replacement (' + replacementCount + ')'"
            [class]="{'p-button-primary': activeTab === 'R', 'p-button-secondary': activeTab !== 'R'}"
            (click)="activeTab = 'R'">
          </button>

        </div>

        <!-- Search -->
        <div class="search-section">
          <span class="p-input-icon-left search-input-wrapper">
            <i class="pi pi-search"></i>
            <input pInputText type="text" [(ngModel)]="globalFilterValue" (input)="onGlobalFilterChange($event)"
              placeholder="Search Quotation, PI, Job, User..." class="search-input" />
          </span>

          <button *ngIf="globalFilterValue" pButton type="button" icon="pi pi-times"
            class="p-button-rounded p-button-text p-button-danger p-button-sm clear-search-btn" (click)="clearSearch()"
            pTooltip="Clear search">
          </button>
        </div>
      </div>

      <!-- Info bar -->
      <div class="search-info" *ngIf="globalFilterValue">
        <i class="pi pi-info-circle"></i>
        Found {{ filteredAndSearchedRecords.length }} of {{ filteredRecords.length }} records
        <button pButton type="button" class="p-button-text p-button-sm clear-search-info" (click)="clearSearch()">
          Clear
        </button>
      </div>

      <!-- Loading -->
      <div *ngIf="recordsLoading" class="table-loading">
        <p-progressSpinner strokeWidth="4"></p-progressSpinner>
        <p>Loading records...</p>
      </div>

      <!-- Table -->
      <p-table *ngIf="!recordsLoading" [value]="filteredAndSearchedRecords" [rows]="10"
        [rowsPerPageOptions]="[5,10,25,50]" [paginator]="true" [scrollable]="true" scrollHeight="60vh"
        [responsiveLayout]="'scroll'" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        styleClass="p-datatable-striped order-table">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="quotationNo" style="width: 22%">
              Quotation No
              <p-sortIcon field="quotationNo"></p-sortIcon>
            </th>
            <th pSortableColumn="piNo" style="width: 18%">
              Proforma Invoice
              <p-sortIcon field="piNo"></p-sortIcon>
            </th>
            <th pSortableColumn="jobNo" style="width: 16%">
              Job Number
              <p-sortIcon field="jobNo"></p-sortIcon>
            </th>
            <th style="width: 12%">Type</th>
            <th pSortableColumn="createdAt" style="width: 16%">
              Created
              <p-sortIcon field="createdAt"></p-sortIcon>
            </th>
            <th pSortableColumn="updatedAt" style="width: 16%">
              Last Edit
              <p-sortIcon field="updatedAt"></p-sortIcon>
            </th>
            <th style="width: 10%; text-align:center">Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-record>
          <tr>

            <!-- Quotation + Stamp -->
            <td>
              <div class="cell-group">

                <div class="quotation-line">
                  <span class="badge-quotation">
                    <i class="pi pi-check-circle"></i>
                    {{ record.quotationNo }}
                  </span>

                  <!-- Replacement stamp -->
                  <span *ngIf="record.isReplacement" class="replacement-stamp" pTooltip="This is a replacement order"
                    tooltipPosition="top">
                    <i class="pi pi-refresh"></i>
                    REPLACEMENT
                  </span>

                  <!-- Replaced stamp -->
                  <span *ngIf="hasReplacement(record)" class="replaced-stamp" pTooltip="This record has been replaced"
                    tooltipPosition="top">
                    <i class="pi pi-times-circle"></i>
                    REPLACED
                  </span>

                  <!-- optional origin info -->
                  <small *ngIf="record.isReplacement && record.replacedFromId"
                    style="font-size: 0.82rem; color: #6b7280; font-style: italic;">
                    (from {{ getOriginalQuotationNo(record.replacedFromId) }})
                  </small>
                </div>

                <div class="cell-meta">
                  <span class="meta-date">
                    <i class="pi pi-calendar"></i>
                    {{ record.quotationDate ? (record.quotationDate | date:'dd/MM/yy') : '-' }}
                  </span>
                </div>

              </div>
            </td>

            <!-- PI -->
            <td>
              <div class="cell-group">
                <span class="badge-pi">
                  <i class="pi pi-file"></i>
                  {{ record.piNo || '-' }}
                </span>

                <div class="cell-meta" *ngIf="record.piNo">
                  <span class="meta-date">
                    <i class="pi pi-calendar"></i>
                    {{ record.piDate ? (record.piDate | date:'dd/MM/yy') : '-' }}
                  </span>
                </div>
              </div>
            </td>

            <!-- Job -->
            <td>
              <div class="cell-group">
                <span class="badge-job">
                  <i class="pi pi-briefcase"></i>
                  {{ record.jobNo || '-' }}
                </span>

                <div class="cell-meta" *ngIf="record.jobNo">
                  <span class="meta-date">
                    <i class="pi pi-calendar"></i>
                    {{ record.jobDate ? (record.jobDate | date:'dd/MM/yy') : '-' }}
                  </span>
                </div>
              </div>
            </td>

            <!-- Doc Type -->
            <td>
              <div class="type-wrap">
                <p-tag [severity]="record.docType === 'D' ? 'danger' : (record.docType === 'ES' ? 'success' : 'info')"
                  [icon]="record.docType === 'D' ? 'pi pi-file-pdf' : (record.docType === 'ES' ? 'pi pi-box' : 'pi pi-inbox')"
                  [value]="getDocTypeLabel(record.docType)">
                </p-tag>

                <p-tag *ngIf="record.isSample" severity="success" icon="pi pi-star" value="Sample" styleClass="ml-2">
                </p-tag>
              </div>
            </td>

            <!-- Created -->
            <td>
              <div class="cell-group">
                <span class="created-user">
                  <i class="pi pi-user"></i>
                  {{ record.createdBy || '-' }}
                </span>

                <div class="cell-meta">
                  <span class="meta-date">
                    <i class="pi pi-calendar-plus"></i>
                    {{ record.createdAt ? (record.createdAt | date:'dd/MM/yy HH:mm') : '-' }}
                  </span>
                </div>
              </div>
            </td>

            <!-- Edited -->
            <td>
              <div class="cell-group" *ngIf="wasRecordEdited(record); else notEdited">
                <span class="edited-user">
                  <i class="pi pi-pencil"></i>
                  {{ record.editedBy || '-' }}
                </span>
                <div class="cell-meta">
                  <span class="meta-date edited">
                    <i class="pi pi-clock"></i>
                    {{ record.updatedAt ? (record.updatedAt | date:'dd/MM/yy HH:mm') : '-' }}
                  </span>
                </div>
              </div>

              <ng-template #notEdited>
                <span class="not-edited-text">
                  <i class="pi pi-minus-circle"></i>
                  Not yet edited
                </span>
              </ng-template>
            </td>

            <!-- Actions -->
            <td class="action-cell">

              <!-- Replacement -->
              <button *ngIf="canCreateReplacement(record)" pButton type="button" icon="pi pi-refresh"
                class="p-button-rounded p-button-help p-button-sm" pTooltip="Create Replacement"
                (click)="openReplacementDialog(record)">
              </button>

              <!-- Edit -->
              <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-sm"
                pTooltip="Edit Record" [disabled]="!canEditRecord(record)" (click)="openEditDialog(record)">
              </button>

              <!-- Delete -->
              <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-sm"
                pTooltip="Delete Record" [disabled]="!canEditRecord(record)" (click)="deleteRecord(record)">
              </button>

            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="empty-message">
              <i class="pi pi-inbox" style="font-size: 3rem; color: var(--surface-400);"></i>
              <div class="empty-message-text">
                <p *ngIf="globalFilterValue">No records found matching "{{ globalFilterValue }}"</p>
                <p *ngIf="!globalFilterValue">
                  No records found.
                  <button pButton type="button" label="Create First" icon="pi pi-plus" class="p-button-text p-button-sm"
                    (click)="openCreateDialog()">
                  </button>
                </p>
              </div>
            </td>
          </tr>
        </ng-template>

      </p-table>

    </div>

    <!-- ===== MAIN (CREATE/EDIT) DIALOG ===== -->
    <p-dialog [(visible)]="displayDialog" [modal]="true" [style]="{width: '820px'}" [draggable]="false"
      [resizable]="false" styleClass="order-number-dialog">

      <ng-template pTemplate="header">
        <div class="custom-dialog-header">
          <i [class]="'pi ' + (dialogMode === 'create' ? 'pi-magic-wand' : 'pi-pencil')"></i>
          {{ dialogMode === 'create' ? 'Generate New Order Numbers' : 'Edit Order Numbers' }}
        </div>
      </ng-template>

      <form [formGroup]="form" (ngSubmit)="saveRecord()">

        <!-- Document type -->
        <div class="form-section">
          <h5><i class="pi pi-folder-open"></i> Document Type</h5>
          <div class="document-selector">

            <div class="radio-option encloser-option">
              <p-radioButton formControlName="docType" [value]="'E'" inputId="docE"></p-radioButton>
              <label for="docE" class="label-text">
                <i class="pi pi-inbox"></i> Encloser (KBX)
              </label>

              <div class="sample-checkbox-wrapper" *ngIf="form.get('docType')?.value === 'E'">
                <p-checkbox formControlName="isSample" [binary]="true" label="Mark as Sample" inputId="isSample">
                </p-checkbox>
              </div>
            </div>

            <div class="radio-option">
              <p-radioButton formControlName="docType" [value]="'D'" inputId="docD"></p-radioButton>
              <label for="docD" class="label-text">
                <i class="pi pi-file-pdf"></i> Drawing (DRW)
              </label>
            </div>

          </div>
        </div>

        <!-- Quotation -->
        <div class="form-row">
          <div class="form-col">
            <h5><i class="pi pi-star-fill"></i> Quotation Number <small>required</small></h5>
            <span class="p-input-icon-left w-full">
              <i class="pi pi-tag"
                [class.p-invalid]="form.get('quotationNo')?.invalid && form.get('quotationNo')?.touched"></i>
              <input pInputText formControlName="quotationNo" class="w-full" placeholder="Auto-generated on Generate"
                [class.p-invalid]="form.get('quotationNo')?.invalid && form.get('quotationNo')?.touched" />
            </span>

            <small *ngIf="form.get('quotationNo')?.pending" class="p-info validation-info">
              <i class="pi pi-spin pi-spinner"></i> Checking availability...
            </small>

            <div *ngIf="form.get('quotationNo')?.errors?.['duplicate'] && form.get('quotationNo')?.touched"
              class="error-message">
              <i class="pi pi-exclamation-triangle"></i> {{ form.get('quotationNo')?.errors?.['duplicate'] }}
            </div>
          </div>
          <div class="form-col">
            <h5><i class="pi pi-calendar"></i> Quotation Date</h5>
            <p-calendar formControlName="quotationDate" dateFormat="dd/MM/yy" [showIcon]="true" appendTo="body"
              styleClass="w-full">
            </p-calendar>
          </div>
        </div>

        <!-- Sample suggestion -->
        <div class="sample-suggestion-banner" *ngIf="showSampleSuggestion && form.get('isSample')?.value">
          <div class="suggestion-header">
            <i class="pi pi-info-circle"></i>
            <span>Choose a quotation type for this sample order:</span>
          </div>

          <div class="suggestion-options">
            <button type="button" pButton class="p-button-outlined p-button-secondary suggestion-btn"
              (click)="suggestNormalQuotation()">
              <i class="pi pi-tag"></i>
              <div class="suggestion-detail">
                <span class="suggestion-label">Normal Quotation</span>
                <strong class="suggestion-number">{{ nextQuotationPreview }}</strong>
              </div>
            </button>

            <span class="or-divider">OR</span>

            <button type="button" pButton class="p-button-outlined p-button-success suggestion-btn"
              (click)="suggestSampleQuotation()">
              <i class="pi pi-box"></i>
              <div class="suggestion-detail">
                <span class="suggestion-label">Sample Quotation</span>
                <strong class="suggestion-number">{{ nextSampleQuotationPreview }}</strong>
              </div>
            </button>
          </div>
        </div>

        <!-- PI -->
        <div class="form-row">
          <div class="form-col">
            <h5><i class="pi pi-receipt"></i> Proforma Invoice</h5>
            <span class="p-input-icon-left w-full">
              <i class="pi pi-dollar"></i>
              <input pInputText formControlName="piNo" class="w-full" placeholder="Auto-generated on Generate" />
            </span>

            <small *ngIf="form.get('piNo')?.pending" class="p-info validation-info">
              <i class="pi pi-spin pi-spinner"></i> Checking availability...
            </small>

            <div *ngIf="form.get('piNo')?.errors?.['duplicate'] && form.get('piNo')?.touched" class="error-message">
              <i class="pi pi-exclamation-triangle"></i> {{ form.get('piNo')?.errors?.['duplicate'] }}
            </div>

            <small class="preview-text clickable" (click)="suggestPINumber()" style="cursor:pointer;">
              <i class="pi pi-eye"></i> Next: <strong>{{ nextPIPreview }}</strong>
            </small>
          </div>

          <div class="form-col">
            <h5><i class="pi pi-calendar"></i> PI Date</h5>
            <p-calendar formControlName="piDate" dateFormat="dd/MM/yy" [showIcon]="true"
              [disabled]="!form.get('piNo')?.value" appendTo="body" styleClass="w-full">
            </p-calendar>
          </div>
        </div>

        <!-- Job -->
        <div class="form-row">
          <div class="form-col">
            <h5><i class="pi pi-briefcase"></i> Job Number</h5>
            <span class="p-input-icon-left w-full">
              <i class="pi pi-sitemap"></i>
              <input pInputText formControlName="jobNo" class="w-full" placeholder="Auto-generated on Generate" />
            </span>

            <small *ngIf="form.get('jobNo')?.pending" class="p-info validation-info">
              <i class="pi pi-spin pi-spinner"></i> Checking availability...
            </small>

            <div *ngIf="form.get('jobNo')?.errors?.['duplicate'] && form.get('jobNo')?.touched" class="error-message">
              <i class="pi pi-exclamation-triangle"></i> {{ form.get('jobNo')?.errors?.['duplicate'] }}
            </div>

            <small class="preview-text clickable" (click)="suggestJobNumber()" style="cursor:pointer;">
              <i class="pi pi-eye"></i> Next: <strong>{{ nextJobPreview }}</strong>
            </small>
          </div>

          <div class="form-col">
            <h5><i class="pi pi-calendar"></i> Job Date</h5>
            <p-calendar formControlName="jobDate" dateFormat="dd/MM/yy" [showIcon]="true"
              [disabled]="!form.get('jobNo')?.value" appendTo="body" styleClass="w-full">
            </p-calendar>
          </div>
        </div>

      </form>

      <!-- Overlay -->
      <div class="full-dialog-overlay" *ngIf="loading || showSuccessState">
        <ng-container *ngIf="loading; else successTemplate">
          <div class="loading-overlay-full">
            <p-progressSpinner strokeWidth="8" styleClass="custom-spinner"></p-progressSpinner>
            <p class="loading-text">{{ currentLoadingMessage || 'Generating...' }}</p>
          </div>
        </ng-container>

        <ng-template #successTemplate>
          <div class="success-overlay-full">
            <div class="success-icon-large">
              <i class="pi pi-check-circle"></i>
            </div>
            <h3 class="success-title">{{ saveSuccessMessage }}</h3>
            <div class="success-number">{{ generatedNumber }}</div>
          </div>
        </ng-template>
      </div>

      <ng-template pTemplate="footer">
        <ng-container *ngIf="!loading && !showSuccessState">
          <button pButton type="button" label="Cancel" icon="pi pi-times"
            class="p-button-text p-button-secondary cancel-red-btn" (click)="closeDialog()">
          </button>

          <button pButton type="button" [label]="dialogMode === 'create' ? 'Generate' : 'Update'" icon="pi pi-check"
            class="p-button-raised p-button-primary" (click)="saveRecord()"
            [disabled]="form.invalid || form.pending || hasDuplicates()">
          </button>
        </ng-container>
      </ng-template>

    </p-dialog>

    <!-- ===== PASSWORD MODAL ===== -->
    <p-dialog [(visible)]="showPasswordModal" [modal]="true" [style]="{width: '450px'}" [draggable]="false"
      [resizable]="false" styleClass="secure-access-dialog" header="Secure Order Number Access" [closable]="false">

      <div class="access-card">
        <div class="access-header">
          <div class="shield-icon">
            <i class="pi pi-shield"></i>
          </div>
          <h3>Authentication Required</h3>
          <p>Enter your access code to manage order numbers</p>
        </div>

        <div class="password-form">
          <div class="p-float-label mb-4">
            <span class="p-input-icon-left">
              <i class="pi pi-lock-fill"></i>
              <input pInputText type="password" [(ngModel)]="enteredPassword" (keyup.enter)="verifyPassword()"
                class="w-full access-input" placeholder=" " autocomplete="new-password" />
            </span>
            <label>Access Password</label>
          </div>

          <div class="access-hint">
            <i class="pi pi-info-circle mr-2"></i>
            <span>Only authorized personnel. Contact admin if needed.</span>
          </div>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancel" icon="pi pi-times-circle"
          class="p-button-outlined p-button-secondary p-button-sm" (click)="cancelAccess()">
        </button>

        <button pButton type="button" label="Authenticate" icon="pi pi-check-circle"
          class="p-button-raised p-button-primary p-button-sm" [loading]="passwordLoading" (click)="verifyPassword()">
        </button>
      </ng-template>

    </p-dialog>

    <!-- ===== REPLACEMENT DIALOG (UPDATED) ===== -->
    <p-dialog [(visible)]="replacementDialogVisible" [modal]="true" [style]="{width: '700px'}" [draggable]="false"
      [resizable]="false" styleClass="replacement-dialog" (onShow)="onReplacementDialogShow()"
      (onHide)="onReplacementDialogHide()">

      <ng-template pTemplate="header">
        <div class="custom-dialog-header">
          <i class="pi pi-refresh"></i>
          {{ dialogMode === 'edit' ? 'Edit Replacement Order' : 'Create Replacement Order' }}
        </div>
      </ng-template>

      <form [formGroup]="replacementForm" class="p-fluid">

        <!-- Top banner -->
        <div class="replacement-banner">
          <div class="banner-left">
            <p-tag severity="warning" icon="pi pi-refresh" value="Replacement"></p-tag>
            <span class="banner-text" *ngIf="dialogMode === 'create'">
              Create a Replacement order for the selected Encloser record.
            </span>
            <span class="banner-text" *ngIf="dialogMode === 'edit'">
              Edit this Replacement order.
            </span>
          </div>

          <div class="banner-right" *ngIf="replacementTarget?.quotationNo">
            <small class="muted">Original:</small>
            <strong class="ml-2">{{ replacementTarget?.quotationNo }}</strong>
          </div>
        </div>

        <!-- Optional helper: show original PI/Job (for reference) -->
        <div class="original-ref" *ngIf="replacementTarget?.piNo || replacementTarget?.jobNo"
          style="margin: 10px 0 14px;">
          <p-tag severity="info" icon="pi pi-info-circle" value="Original Values"></p-tag>
          <div style="margin-top:8px;">
            <small class="muted" *ngIf="replacementTarget?.piNo">
              PI: <strong>{{ replacementTarget?.piNo }}</strong>
            </small>
            <span style="margin:0 10px;" *ngIf="replacementTarget?.piNo && replacementTarget?.jobNo">|</span>
            <small class="muted" *ngIf="replacementTarget?.jobNo">
              Job: <strong>{{ replacementTarget?.jobNo }}</strong>
            </small>
          </div>
        </div>

        <!-- Replacement Order -->
        <div class="form-row">
          <div class="form-col">
            <h5><i class="pi pi-tag"></i> Replacement Order NB <small>required</small></h5>
            <input pInputText formControlName="replacementOrderNo" class="w-full" />
            <small class="p-error"
              *ngIf="replacementForm.get('replacementOrderNo')?.touched && replacementForm.get('replacementOrderNo')?.invalid">
              Required
            </small>
          </div>

          <div class="form-col">
            <h5><i class="pi pi-calendar"></i> Replacement Date <small>required</small></h5>
            <p-calendar formControlName="replacementDate" appendTo="body" dateFormat="dd/MM/yy" [showIcon]="true"
              styleClass="w-full">
            </p-calendar>
            <small class="p-error"
              *ngIf="replacementForm.get('replacementDate')?.touched && replacementForm.get('replacementDate')?.invalid">
              Required
            </small>
          </div>
        </div>

        <!-- PI (optional) -->
        <div class="form-row">
          <div class="form-col">
            <div class="field-head">
              <h5><i class="pi pi-receipt"></i> Proforma Invoice</h5>
              <p-tag severity="info" value="Optional"></p-tag>
            </div>

            <input pInputText formControlName="piNo" class="w-full" placeholder="Leave empty if not needed"
              (input)="onReplacementPIInput()" />

            <!-- ✅ Next preview (same behavior as Generate dialog) -->
            <small class="preview-text clickable" style="cursor:pointer; display:block; margin-top:6px;"
              *ngIf="nextReplacementPIPreview && !replacementForm.get('piNo')?.value?.trim()"
              (click)="suggestReplacementPI()">
              <i class="pi pi-eye"></i> Next: <strong>{{ nextReplacementPIPreview }}</strong>
            </small>
          </div>

          <div class="form-col">
            <div class="field-head">
              <h5><i class="pi pi-calendar"></i> PI Date</h5>
              <p-tag severity="info" value="Auto required"></p-tag>
            </div>

            <p-calendar formControlName="piDate" dateFormat="dd/MM/yy" [showIcon]="true" appendTo="body"
              styleClass="w-full">
            </p-calendar>

            <small class="p-error"
              *ngIf="replacementForm.get('piNo')?.value?.trim() && replacementForm.get('piDate')?.touched && replacementForm.get('piDate')?.invalid">
              Date required when PI is filled
            </small>
          </div>
        </div>

        <!-- Job (optional) -->
        <div class="form-row">
          <div class="form-col">
            <div class="field-head">
              <h5><i class="pi pi-briefcase"></i> Job Number</h5>
              <p-tag severity="info" value="Optional"></p-tag>
            </div>

            <input pInputText formControlName="jobNo" class="w-full" placeholder="Leave empty if not needed"
              (input)="onReplacementJobInput()" />

            <!-- ✅ Next preview (same behavior as Generate dialog) -->
            <small class="preview-text clickable" style="cursor:pointer; display:block; margin-top:6px;"
              *ngIf="nextReplacementJobPreview && !replacementForm.get('jobNo')?.value?.trim()"
              (click)="suggestReplacementJob()">
              <i class="pi pi-eye"></i> Next: <strong>{{ nextReplacementJobPreview }}</strong>
            </small>
          </div>

          <div class="form-col">
            <div class="field-head">
              <h5><i class="pi pi-calendar"></i> Job Date</h5>
              <p-tag severity="info" value="Auto required"></p-tag>
            </div>

            <p-calendar formControlName="jobDate" appendTo="body" dateFormat="dd/MM/yy" [showIcon]="true"
              styleClass="w-full">
            </p-calendar>

            <small class="p-error"
              *ngIf="replacementForm.get('jobNo')?.value?.trim() && replacementForm.get('jobDate')?.touched && replacementForm.get('jobDate')?.invalid">
              Date required when Job is filled
            </small>
          </div>
        </div>

        <!-- Loading -->
        <div *ngIf="replacementLoading" class="dialog-loading" style="margin-top: 14px; text-align:center;">
          <p-progressSpinner strokeWidth="4"></p-progressSpinner>
          <p style="margin-top:8px;">Generating replacement numbers...</p>
        </div>

      </form>

      <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-text p-button-secondary"
          [disabled]="replacementLoading" (click)="closeReplacementDialog()">
        </button>

        <button pButton type="button" [label]="dialogMode === 'edit' ? 'Update Replacement' : 'Create Replacement'"
          icon="pi pi-check" class="p-button-primary" [loading]="replacementLoading"
          [disabled]="replacementForm.invalid" (click)="saveReplacement()">
        </button>
      </ng-template>

    </p-dialog>


    <!-- Toast -->
    <p-toast position="top-right"></p-toast>

  </div>
</div>